import React from 'react';
import PropTypes from 'prop-types';

const MainLayout = ({ children }) => (
  <div className="App flex flex-col min-h-screen bg-blue-50">
    {children}
  </div>
);

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainLayout;
